/**
 * Blurs every image/video on the page while it's loading, then sharpens it
 * once its content actually arrives. Purely reactive to the browser's own
 * native load events - never fetches or requests anything the page wasn't
 * already going to load (no prefetching, no extra network requests).
 */
(function () {
  var LOADING_CLASS = 'global-blur-up';
  var LOADED_CLASS = 'global-blur-up--loaded';

  function markLoaded(el) {
    el.classList.add(LOADED_CLASS);
  }

  function watchImage(img) {
    if (img.dataset.blurUpWatched) return;
    img.dataset.blurUpWatched = 'true';
    if (img.complete && img.naturalWidth > 0) return;
    img.classList.add(LOADING_CLASS);
    img.addEventListener('load', function () { markLoaded(img); }, { once: true });
    img.addEventListener('error', function () { markLoaded(img); }, { once: true });
  }

  function watchVideo(video) {
    if (video.dataset.blurUpWatched) return;
    video.dataset.blurUpWatched = 'true';
    if (video.readyState >= 2) return;
    video.classList.add(LOADING_CLASS);
    video.addEventListener('loadeddata', function () { markLoaded(video); }, { once: true });
    video.addEventListener('error', function () { markLoaded(video); }, { once: true });

    var poster = video.getAttribute('poster');
    if (poster) {
      var posterImg = new Image();
      posterImg.onload = function () { markLoaded(video); };
      posterImg.src = poster;
    }
  }

  function scan(root) {
    if (root.tagName === 'IMG') {
      watchImage(root);
      return;
    }
    if (root.tagName === 'VIDEO') {
      watchVideo(root);
      return;
    }
    if (!root.querySelectorAll) return;
    root.querySelectorAll('img').forEach(watchImage);
    root.querySelectorAll('video').forEach(watchVideo);
  }

  scan(document.documentElement);

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) scan(node);
      });
    });
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
